'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { useInitiatives } from '@/lib/hooks/useInitiatives';
import { useSiteSettings } from '@/lib/hooks/useSiteSettings';
import { InitiativeCard } from '../initiatives/InitiativeCard';
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from '@/components/ui/carousel';
export function OfficeHoursSection() {
  const $ = _c(46);
  const {
    settings
  } = useSiteSettings();
  const hubConfig = settings.officeHoursHub;
  let t0;
  if ($[0] !== hubConfig) {
    t0 = hubConfig ? {
      limit: 10,
      visibility: "public",
      isTemplate: false,
      requiredSystemTags: [`@hub=${hubConfig.id}`]
    } as any : undefined;
    $[0] = hubConfig;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !!hubConfig;
  let t2;
  if ($[2] !== t1) {
    t2 = {
      enabled: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data,
    isLoading
  } = useInitiatives(t0, t2);
  let T0;
  let T1;
  let t10;
  let t11;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] !== data?.pages || $[5] !== hubConfig || $[6] !== isLoading) {
    t11 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const initiatives = data?.pages?.flatMap(_temp) ?? [];
      if (!hubConfig) {
        t11 = null;
        break bb0;
      }
      if (isLoading) {
        let t12;
        if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
          t12 = <h2 className="text-4xl font-extrabold tracking-tight text-gray-900 mb-8 sm:text-5xl">{"Your next move often starts with a conversation"}</h2>;
          $[18] = t12;
        } else {
          t12 = $[18];
        }
        let t13;
        if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
          t13 = <section className="py-16"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{t12}<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">{Array.from({
                  length: 3
                }).map(_temp2)}</div></div></section>;
          $[19] = t13;
        } else {
          t13 = $[19];
        }
        t11 = t13;
        break bb0;
      }
      if (!initiatives.length) {
        t11 = null;
        break bb0;
      }
      t10 = "py-16";
      t7 = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
      if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = <div className="mb-4"><h2 className="text-4xl font-extrabold tracking-tight text-gray-900 mb-0 sm:text-5xl">{"Your next move often starts with a conversation"}</h2></div>;
        t9 = <p className="text-lg text-gray-500 mb-2 max-w-2xl">Figuring out your next move often starts with talking through things with the right expert. Discover and connect with expert helpers in scheduled or on demand office hours .</p>;
        $[20] = t8;
        $[21] = t9;
      } else {
        t8 = $[20];
        t9 = $[21];
      }
      T1 = Carousel;
      if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
          align: "start",
          loop: false
        };
        $[22] = t5;
      } else {
        t5 = $[22];
      }
      t6 = "w-full";
      T0 = CarouselContent;
      t3 = "-ml-4";
      t4 = initiatives.map(_temp3);
    }
    $[4] = data?.pages;
    $[5] = hubConfig;
    $[6] = isLoading;
    $[7] = T0;
    $[8] = T1;
    $[9] = t10;
    $[10] = t11;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    T0 = $[7];
    T1 = $[8];
    t10 = $[9];
    t11 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  if (t11 !== Symbol.for("react.early_return_sentinel")) {
    return t11;
  }
  let t12;
  if ($[23] !== T0 || $[24] !== t3 || $[25] !== t4) {
    t12 = <T0 className={t3}>{t4}</T0>;
    $[23] = T0;
    $[24] = t3;
    $[25] = t4;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <CarouselPrevious className="-left-4 lg:left-0" />;
    t14 = <CarouselNext className="-right-4 lg:right-0" />;
    $[27] = t13;
    $[28] = t14;
  } else {
    t13 = $[27];
    t14 = $[28];
  }
  let t15;
  if ($[29] !== T1 || $[30] !== t12 || $[31] !== t5 || $[32] !== t6) {
    t15 = <T1 opts={t5} className={t6}>{t12}{t13}{t14}</T1>;
    $[29] = T1;
    $[30] = t12;
    $[31] = t5;
    $[32] = t6;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const t16 = `/content/${hubConfig.slug}`;
  let t17;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <ArrowRight className="h-4 w-4" aria-hidden="true" />;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t16) {
    t18 = <div className="mt-10 text-center"><Link href={t16} className="inline-flex cursor-pointer items-center gap-2 rounded-full bg-[#ff5a36] px-7 py-3.5 text-base font-black text-white shadow-lg shadow-red-500/20 transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-red-500/30">View All Office Hours{t17}</Link></div>;
    $[35] = t16;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t15 || $[38] !== t18 || $[39] !== t7 || $[40] !== t8 || $[41] !== t9) {
    t19 = <div className={t7}>{t8}{t9}{t15}{t18}</div>;
    $[37] = t15;
    $[38] = t18;
    $[39] = t7;
    $[40] = t8;
    $[41] = t9;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t10 || $[44] !== t19) {
    t20 = <section className={t10}>{t19}</section>;
    $[43] = t10;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  return t20;
}
function _temp3(initiative) {
  return <CarouselItem key={initiative.id} className="pl-4 basis-full sm:basis-1/2 lg:basis-1/3"><InitiativeCard initiative={initiative} showOwner={true} showStatus={true} showInterestCount="non-zero" showUserInterested={true} showTags={false} /></CarouselItem>;
}
function _temp2(_, i) {
  return <div key={i} className="h-[300px] rounded-2xl bg-gray-200 animate-pulse" />;
}
function _temp(page) {
  return page.initiatives;
}